import Sidebar from "./Sidebar";

export default function Layout({
  children,
}) {
  return (
    <div className="bg-gray-100 min-h-screen relative overflow-hidden">
      
      {/* Sidebar */}
      <Sidebar />

      {/* Watermark Background */}
      <div className="fixed inset-0 flex items-center justify-center pointer-events-none z-0">
        <h1 className="text-[120px] font-extrabold text-black opacity-[0.03] tracking-widest select-none">
          SYNOWEB
        </h1>
      </div>

      {/* Main Content */}
      <div className="ml-72 p-6 min-h-screen relative z-10">
        {children}
      </div>

      {/* Bottom Watermark */}
      <div className="fixed bottom-4 left-1/2 -translate-x-1/2 pointer-events-none z-10">
        <p className="text-sm text-gray-400 font-medium tracking-wide">
          Powered by{" "}
          <span className="font-semibold text-gray-900">
            Synoweb
          </span>
        </p>
      </div>
    </div>
  );
}